import { get as getToken } from '@nicolaudie-group/ng-ui-kit/helpers/tokens'

import config from '@/config'
import * as sdk from '@/helpers/sdk'

function buildDownloadLink(uid, format, optimization = true) {
  const profileDownloadBaseUrl = sdk.v3.buildUrl(
    sdk.v3.profiles.download.routes['3.0.0'],
    {
      url: { profileUid: uid, format },
      format,
    },
  )
  const token = encodeURIComponent(getToken())
  return config.urlTemplates.profileDownload.template({
    profileDownloadBaseUrl,
    enableOptimization: optimization,
    token,
  })
}

export default buildDownloadLink
